// Character coverage of the bundled font files. Whitespace may use its normal
// fallback metrics; select a single face for the rest of each localized run.
const LUCKIEST_GUY =
    /^[\s\u0020-\u007e\u00a0-\u017e\u01fc-\u01ff\u0237\u02c6-\u02c7\u02d8-\u02dd\u0312\u0315\u0326\u03bc\u1e80-\u1e85\u1ef2-\u1ef3\u2013-\u2014\u2018-\u201a\u201c-\u201e\u2020-\u2022\u2026\u2030\u2039-\u203a\u2044\u20ac\u2122\u2202\u2212\u2248\u2260\ufb01-\ufb02]+$/u;
const LILITA_ONE =
    /^[\s\u0020-\u007e\u00a1-\u00ae\u00b0-\u00ff\u0131\u0141-\u0142\u0152-\u0153\u0160-\u0161\u0178\u017d-\u017e\u0192\u02c6-\u02c7\u02da\u02dc\u2013-\u2014\u2018-\u201a\u201c-\u201e\u2020-\u2022\u2026\u2030\u2039-\u203a\u2044\u20ac\u2122\u2212\ufb01-\ufb02]+$/u;

type OfferDisplayFont = "luckiest-guy" | "lilita-one" | "locale";

export function offerDisplayFont(
    text: string,
    preferred: Exclude<OfferDisplayFont, "locale">,
): OfferDisplayFont {
    const supported = {
        "luckiest-guy": LUCKIEST_GUY.test(text),
        "lilita-one": LILITA_ONE.test(text),
    };
    if (supported[preferred]) return preferred;
    if (supported["luckiest-guy"]) return "luckiest-guy";
    if (supported["lilita-one"]) return "lilita-one";
    return "locale";
}
